import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'fl-highlight-callout',
  template: ` <ng-content></ng-content> `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HighlightCalloutComponent {}
